import queryString from 'query-string';

import { createAxiosInstance } from '~/plugins/axios.plugin';

class LtiService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API, useAccessToken: true });
    this.clientV2 = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API_V2, useAccessToken: true });
  }

  getLtiForm(params) {
    return this.client.get(`/content/lti/launch`, { params });
  }

  postLtiIntegration() {
    return this.client.post(`/academic/ltiIntegration`);
  }

  getProviderList(page, limit, sortBy, order, searchProvider) {
    const stringified = queryString.stringify({ page, limit, sortBy, order, filter: searchProvider }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`/content/lti/list${stringified && `?${stringified}`}`);
  }

  getAllByRoleAlias(roleAlias) {
    return this.client.get(`/content/lti/tool/list-by-alias/${roleAlias}`);
  }

  createLtiProvider(ltiProvider) {
    return this.client.post('/content/lti', ltiProvider);
  }

  getLtiProvider(ltiProviderId) {
    return this.client.get(`/content/lti/${ltiProviderId}`);
  }

  editLtiProvider(ltiProvider) {
    return this.client.put(`/content/lti/${ltiProvider.id}`, ltiProvider);
  }

  deleteLtiProvider(id) {
    return this.client.delete(`/content/lti/${id}`);
  }

  createLtiProviderTool(ltiTool) {
    return this.client.post('/content/lti/tool', ltiTool);
  }

  editLtiProviderTool(ltiTool) {
    return this.client.put(`/content/lti/tool/${ltiTool.id}`, ltiTool);
  }

  deleteLtiProviderTool(id) {
    return this.client.delete(`/content/lti/tool/${id}`);
  }

  getToolListByProviderId(page, limit, sortBy, order, providerId, filter) {
    const stringified = queryString.stringify({ page, limit, sortBy, order, providerId, filter }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`/content/lti/tool/list/${providerId}${stringified && `?${stringified}`}`);
  }

  getAcademicMainContentsForLTILinkGeneration(academicMainId) {
    return this.clientV2.get(`/content/academics-main/${academicMainId}/lti/links`);
  }
}

export default new LtiService();
